// Module
var code = `<h1>Email</h1> <h3 class="metric-meaning">Что значит?</h3><p>Трафик полученный из web-почтовых клиентов на сайт</p> `;
// Exports
module.exports = code;